module.exports = __webpack_public_path__ + "static/media/Holcim.7c7c7986.png";